// extracted by mini-css-extract-plugin
export default {"chip":"Home_chip__DpzXb","badge":"Home_badge__qy8Dy","categoriesGrid":"Home_categoriesGrid__2q54n"};